import { useQuery } from '@tanstack/react-query';

import { reportingLeDataSharedSessionPath } from '~/consts/reportingLeDataApi';

import { request } from '~/services/common';

import type { LeDataSessionResponse } from '~/types/leData';

import { getLeDataApiErrorMessage } from '~/utils/leData/getLeDataApiErrorMessage';
import { parseLeDataSessionResponse } from '~/utils/mapLeDataSessionToMessages';
import { resolveReportingLeDataUrl } from '~/utils/resolveReportingLeDataUrl';

export const reportingLeDataSharedSessionQueryKeys = {
  all: ['reporting', 'le-data', 'shared-session'] as const,
  detail: (sessionId: string) => [...reportingLeDataSharedSessionQueryKeys.all, sessionId] as const,
};

export function useGetReportingLeDataSharedSession(sessionId: string | null, enabled = true) {
  return useQuery<LeDataSessionResponse>({
    queryKey: reportingLeDataSharedSessionQueryKeys.detail(sessionId ?? ''),
    queryFn: async ({ signal }) => {
      try {
        if (!sessionId) {
          throw new Error('Session ID is required');
        }
        const url = resolveReportingLeDataUrl(reportingLeDataSharedSessionPath(sessionId));
        const data = await request(url, { signal });
        return parseLeDataSessionResponse(data);
      } catch (error) {
        throw new Error(getLeDataApiErrorMessage(error), { cause: error });
      }
    },
    enabled: Boolean(sessionId) && enabled,
    staleTime: 0,
  });
}
